import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core';
import LibrarySectionList from '../LibrarySectionList'
import MostTrendingItem from './MostTrendingItem'
import { getPreviewImageFromAttachments } from '@tuqqi/common';
import { librarySections } from '../../../../../utils/library/librarySections';

const INFO_SECTION_WIDTH = 264
const ITEMS_SECTION_WIDTH = 1022

const styles = theme => ({
    mostTrendingItems: {
        height: 620,
        marginTop: 48,
        width: '100%'
    },
    container: {
        height: 620,
        position: 'relative',
        background: 'url(``) no-repeat center center', 
        '-webkit-background-size': 'cover',
        '-moz-background-size': 'cover',
        '-o-background-size': 'cover',
        'background-size': 'cover',
    },
    overlay: {
        position: 'absolute',
        width: 'auto',
        height: 'auto',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,   
    },
    headerSection: {
        flexDirection: 'column',
        width: INFO_SECTION_WIDTH
    },
    topText: {
        paddingLeft: 32,
        opacity: 0.6,
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'italic',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#ffffff',
    },
    mostTrendingNum: {
        marginTop: -12,
        fontFamily: 'Rubik',
        fontSize: 96,
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'italic',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#ffffff',
    },
    title: {
        marginTop: 4,
        fontFamily: 'Rubik',
        fontSize: 22,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#ffffff',
    },
    subtitle: {
        marginTop: 12,
        opacity: 0.6,
        fontFamily: 'Rubik',
        fontSize: 18,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#ffffff',
    },
    controlButtons: {
        flexDirection: 'column',
        border: 'solid 2px rgba(235, 235, 235, 0.5)',
        borderRadius: 4,
        width: 84,
        height: 38,
        marginRight: 0,
        marginLeft: 'auto',
        marginTop: 24,
    },
    itemsSection: {
        width: ITEMS_SECTION_WIDTH,
        flexDirection: 'column'
    },
    disableIcon:{
        fill: theme.newUI.color.gray
    },
    activeIcon:{
        cursor: 'pointer',
        fill: '#fff'
    },
    leftButton: {
        width: 42,
        height: 38,
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: 'none',
    },
    rightButton: {
        width: 42,
        height: 38,
        borderRadius: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        border: 'none',
        borderLeft: 'solid 2px rgba(235, 235, 235, 0.5)',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    buttonAll: {
        marginTop: 48,
        border: 'solid 2px rgba(235, 235, 235, 0.5)',
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
        '&:hover': {
            boxShadow: '1px 1px 1px #151515',
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
        },
        '&:active': {
            boxShadow: 'inset 1px 1px 1px #202020'
        }
    },
    allText: {
        color: '#ffffff',
    },
    items: {
        height: '100%'
    },
    controlWrap: {
        width: 1022,
        bottom: 5,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    listContainer: {
        height: 550,
    },
    cardsContainer: {
        display: 'grid',
        gridAutoFlow: 'column',
        gridTemplateColumns: 'auto auto auto auto',
        justifyContent: 'flex-start'
    },
});

const mapItems = (results) => {
    return results.map(result => {
        const doc = result.Value.Source
        const imageUrl = getPreviewImageFromAttachments(doc)
        return {
            title: doc.title || '',
            subtitle:  doc.docText || '',
            backgroundImage: imageUrl || '',
            itemId: doc.docId
        }
    })
}
const SCREEN_ITEMS = 4
const query = {
    page: 0,
    AggType: 'FLAT',
    // itemsIds: ids,
    // size: ids.length,
}

const MostTrendingItems = (props) => {
    const {classes, adminService, queryService} = props
    const [items, setItems] = useState([])

    useEffect(() => {
        (async () => {
            adminService.getSponsoredContent().then((docIds) => {
                if (!docIds || !docIds.length) return
                const q = {...query, itemsIds: docIds, size: docIds.length}
                queryService.SearchByIds(q).then((results) => {
                    setItems(mapItems(results.data))
                })
            })
        })()
    }, [])

    const controlStyles = {
        controlWrap: classes.controlWrap,
        controlButtons: classes.controlButtons,
        leftButton: classes.leftButton,
        rightButton: classes.rightButton,
        activeIcon: classes.activeIcon,
        disableIcon: classes.disableIcon,
        arrowBg: 'transparent'
    }
    const texts = librarySections().mostTrendingItems

        return (
        <div data-intrcm-id="MostTrendingItems_qbbb5l70" className={classes.mostTrendingItems}>
            <div data-intrcm-id="MostTrendingItems_zdv6qpnm" style={{backgroundImage: `url(${require('../../../../../assets/img/trending-items-background.jpg')})`}} className={classes.container}>
              <div data-intrcm-id="MostTrendingItems_vezbpn53" className={classes.overlay}>
                <div data-intrcm-id="MostTrendingItems_i0xowaan" style={{width: INFO_SECTION_WIDTH+ITEMS_SECTION_WIDTH, marginRight: 'auto', marginLeft: 'auto', paddingBottom: 32, paddingTop: 48, height: 'calc(100% - 80px)'}}>
                <div data-intrcm-id="MostTrendingItems_bgs8e1fc" style={{display: 'flex', flexDirection: 'row', width: '100%', height: '100%', alignItems: 'center',}}>
                    <div data-intrcm-id="MostTrendingItems_si3dhoyp" className={classes.headerSection} >
                        {items.length > 0 && <div data-intrcm-id="MostTrendingItems_prdx0s58" className={classes.mostTrendingNum}>{items.length}</div>}
                        <div data-intrcm-id="MostTrendingItems_kh3pffoo" className={classes.title}>{items.length > 0 ? texts.title : texts.noTitle}</div>
                        <div data-intrcm-id="MostTrendingItems_1wts8nue" className={classes.subtitle}>{items.length > 0 ? texts.subtitle : texts.noSubtitle}</div>
                    </div>
                        
                    <div data-intrcm-id="MostTrendingItems_dfz3lc9o" className={classes.itemsSection}>
                        <div data-intrcm-id="MostTrendingItems_7jq1o0e0" className={classes.items}>
                        <LibrarySectionList hideControl={items.length < SCREEN_ITEMS} screenSize={1} listContainerStyle={classes.listContainer} cardsContainerStyle={classes.cardsContainer} controlStyles={controlStyles} >
                            {items.map((item, i) => (
                                <MostTrendingItem key={i} item={item} />
                            ))}
                        </LibrarySectionList>
                        </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
        </div>
        )
}

const mapStateToProps = (state) => ({
    adminService: state.services.adminService,
    queryService: state.services.queryService
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps))(MostTrendingItems);


